module.exports = __webpack_public_path__ + "static/media/bg-post-top-group.69544031.svg";